// pages/TelegramAccounts.js
import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Card,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress ,

} from '@mui/material';
import { Add, Edit, Delete, VerifiedUser } from '@mui/icons-material';
import ApiService from '../../API/Requesthandler'
export default function TelegramAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [phoneHash,setPhoneHash] = useState("");
  const user_id = JSON.parse(localStorage.getItem("user-data"))['id']
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [open2FADialog, setOpen2FADialog] = useState(false);
  const [twoFAPassword, setTwoFAPassword] = useState('');
  const [is2FALoading, setIs2FALoading] = useState(false);
  const [twoFAErrorMessage, setTwoFAErrorMessage] = useState('');
  
  const handleVerifyOtp = async () => {
    setIsLoading(true);
    setErrorMessage("");


    

    try {
      await handleAddAccount(otp); // Assuming handleAddAccount accepts OTP and verifies it
      setOpenOtpDialog(false); // Close the dialog on successful verification
    } catch (error) {
      setErrorMessage("Invalid OTP, please try again.");
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(()=>{
    getSessions()
  },[])

  const getSessions = ()=>{
    ApiService.post("/api/phone/sessions",{"user_id":JSON.parse(localStorage.getItem("user-data"))['id']})
    .then(response =>{
      const formattedSessions = response.map((session)=>({
          id: session.id,
          phone:session.phone,
          status: "active",
          lastActive: new Date().toISOString(),
          user_id:session.user_id,
          session:session.session,
          default: session.default,
          username : session.username
      }));
      setAccounts(formattedSessions);
    }).catch(err =>{
      console.log(err)
    })
  }

  const handleAddAccount = () => {
    const body = {
      "phone":phone,
      "otp":otp,
      "user_id":JSON.parse(localStorage.getItem("user-data"))['id'],
      "phone_hash":phoneHash
    }
    ApiService.post("/api/phone/verify_otp",body)
    .then(response =>{
      console.log(response)
      if (response.success && !response.status){
        const newAccount = {
          id: Date.now(),
          phone,
          status: 'active',
          lastActive: new Date().toISOString(),
          groups: []
        };
        setAccounts([...accounts, newAccount]);
        setPhone('');
        setOpenOtpDialog(false);
      }else if (response.status === "2fa"){
          setOpen2FADialog(true);
          setOpenOtpDialog(false);
      }
    }).catch(err=>{
      console.log(err)
    })

    
  };

  const handleVerify2FA = async () => {
    setIs2FALoading(true);
    setTwoFAErrorMessage('');
    
    try {
      const body = {
        "user_id": JSON.parse(localStorage.getItem("user-data"))['id'],
        "phone": phone,
        "twofa_password": twoFAPassword,
        "phone_hash": phoneHash
      };
      
      const response = await ApiService.post('/api/phone/verify_2fa', body);
      if (response.success) {
        setOpen2FADialog(false);
        setTwoFAPassword('');
        getSessions();
      } else {
        setTwoFAErrorMessage(response.message || 'Invalid 2FA password');
      }
    } catch (error) {
      setTwoFAErrorMessage('Failed to verify 2FA. Please try again.');
    } finally {
      setIs2FALoading(false);
    }
  };

  const filteredAccounts = accounts.filter(acc => 
    statusFilter === 'all' ? true : acc.status === statusFilter
  );

  const handleDelete = (account) =>{
    // console.log(account)
    const body = {
      "user_id":account.user_id,
      "phone":account.phone
    }
    ApiService.post('/api/phone/delete',body)
    .then(response =>{
      // console.log(response)
      if (response.success == true){
        getSessions()
        // alert("Deleted successfully!")
      }else{
        alert(response.message)
      }
      
    }).catch(err=>{
      console.log(err)
    })
  }
  const handleAddPhone = ()=>{
    
    if (phone.length < 5){return;}
    setIsLoading(true)
    const body = {
      "user_id":user_id,
      "phone":phone.replaceAll(" ","")
    }
    
    ApiService.post('/api/phone/get_otp',body)
    .then(response =>{
      // console.log(response)
      if (response.phone_hash){
        setPhoneHash(response.phone_hash)
        setOpenOtpDialog(true)
        setIsLoading(false)
      }else{
        alert(response.message)
        setIsLoading(false)
      }
      
    }).catch(err=>{
      console.log(err)
      setIsLoading(false)
    })

    

  }

  const handleChange = (e) => {
    // const formatted = formatPhoneNumber(e.target.value);
    setPhone(e.target.value);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
  
    // Remove non-numeric characters
    const cleaned = value.replace(/\D/g, "");
  
    // Format based on length (Supports US, international formats)
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    if (cleaned.length <= 10) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  
    return `+${cleaned}`;
  };


  const ChooseDefault = (account)=>{
    // alert(account.user_id)

    ApiService.post("/api/phone/activate_phone",{
      "user_id":account.user_id,
      "phone":account.phone
    }).then(res=>{
      if (res.success){
        alert("done...")
      }
    })
  }
  return (
    <Container maxWidth="xxl">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <TextField
                label="Phone Number"
                value={phone}
                onChange={handleChange}
                variant="outlined"
                size="small"
              />
              <Button
                variant="contained"
                startIcon={<Add />}
                
                disabled = {isLoading || phone.length < 9}
                onClick={handleAddPhone}
              >
                Add Account
              </Button>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Last Active</TableCell>
                  <TableCell>Added By</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredAccounts.map((account) => (
                  <TableRow key={account.phone}>
                    <TableCell style={{fontWeight:550,color:'gray'}}>{account.phone}</TableCell>
                    <TableCell>
                      <span style={{
                        color: account.status === 'active' ? '#1de9b6' : '#ff5252',
                        fontWeight: 500
                      }}>
                        {account.status}
                      </span>
                    </TableCell>
                    <TableCell>{new Date(account.lastActive).toLocaleString()}</TableCell>
                    <TableCell>
                      <Button variant="outlined" size="small">
                        {account.username}
                      </Button>
                    </TableCell>
                    <TableCell>
                      {/* <Button size="small"><Edit /></Button> */}
                      
                      {/* {
                        account.default == 0 ? (
                          <Button variant="outlined" size="small" onClick={()=>{ChooseDefault(account)}}>
                        Activate
                      </Button>
                        ): <Button variant="contained" size="small">
                        Active
                      </Button>
                      } */}
                      <Button size="small" color="error" onClick={()=>{handleDelete(account)}}><Delete /></Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      <Dialog open={openOtpDialog}   maxWidth="sm" fullWidth >
      <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: 600, color: '#333' }}>OTP Verification</DialogTitle>
      <DialogContent sx={{ padding: '20px 20px 10px', color: '#555' }}>
        <div style={{ marginBottom: '15px', fontSize: '1rem', fontWeight: 500 }}>
          Enter the verification code sent to <span style={{ fontWeight: 600 }}>{phone}</span>
        </div>
        <TextField
          autoFocus
          margin="dense"
          label="Enter OTP"
          type="number"
          fullWidth
          variant="outlined"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          error={!!errorMessage}
          helperText={errorMessage}
          inputProps={{ maxLength: 6 }}
          sx={{
            '& .MuiInputBase-root': {
              borderRadius: '8px',
              backgroundColor: '#f9f9f9',
              // boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ccc',
              },
              '&:hover fieldset': {
                borderColor: '#0066cc',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#0066cc',
              },
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ padding: '15px 20px' }}>
        <Button 
          onClick={() => setOpenOtpDialog(false)} 
          color="default" 
          sx={{ 
            padding: '6px 20px', 
            fontWeight: 600, 
            backgroundColor: '#f0f0f0', 
            '&:hover': { backgroundColor: '#e0e0e0' } 
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleVerifyOtp}
          disabled={isLoading || otp.length !== 5}
          sx={{
            padding: '8px 20px',
            fontWeight: 600,
            backgroundColor: '#0066cc',
            '&:hover': { backgroundColor: '#005bb5' },
            '&.Mui-disabled': {
              backgroundColor: '#b0c4de',
              color: '#ffffff',
            },
          }}
        >
          {isLoading ? <CircularProgress size={24} color="inherit" /> : "Verify"}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={open2FADialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
          Two-Factor Authentication Required
        </DialogTitle>
        <DialogContent sx={{ pt: '20px!important' }}>
          <TextField
            autoFocus
            fullWidth
            label="2FA Password"
            type="password"
            variant="outlined"
            value={twoFAPassword}
            onChange={(e) => setTwoFAPassword(e.target.value)}
            error={!!twoFAErrorMessage}
            helperText={twoFAErrorMessage}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpen2FADialog(false)}
            color="secondary"
            disabled={is2FALoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleVerify2FA}
            color="primary"
            variant="contained"
            disabled={is2FALoading || !twoFAPassword}
          >
            {is2FALoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}